import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { faTrashCan } from '@fortawesome/pro-solid-svg-icons';

@Component({
    selector: 's2-date-button-picker',
    templateUrl: './date-button-picker.component.html',
    styleUrls: ['./date-button-picker.component.scss'],
    standalone: false
})
export class DateButtonPickerComponent {

    @Input() modelDate?: Date | null = null;
    @Input() yearsBefore: number = 5;
    @Input() yearsAfter: number = 5;
    @Input() isAbrreviatedDays: boolean = false;
    @Input() useAllButtons: boolean = false;

    @Output() modelDateOut = new EventEmitter<Date>();

    isMonthShowing = false;
    isDayShowing = false;
    isYearShowing = false;
    is31Days = false;
    is30Days = false;
    is29Days = false;
    is28Days = false;

    years = [];
    months = [ 
        ["01", "JAN"]
        , ["02", "FEB"] 
        , ["03", "MAR"] 
        , ["04", "APR"] 
        , ["05", "MAY"] 
        , ["06", "JUN"] 
        , ["07", "JUL"] 
        , ["08", "AUG"] 
        , ["09", "SEP"] 
        , ["10", "OCT"] 
        , ["11", "NOV"] 
        , ["12", "DEC"]         
    ];
    days31 = [
        "01","02","03","04","05","06","07","08","09","10"
        ,"11","12","13","14","15","16","17","18","19","20"
        ,"21","22","23","24","25","26","27","28","29","30"
        ,"31"
    ];
    days30 = [
        "01","02","03","04","05","06","07","08","09","10"
        ,"11","12","13","14","15","16","17","18","19","20"
        ,"21","22","23","24","25","26","27","28","29","30"
    ];
    days29 = [
        "01","02","03","04","05","06","07","08","09","10"
        ,"11","12","13","14","15","16","17","18","19","20"
        ,"21","22","23","24","25","26","27","28","29"
    ];
    days28 = [
        "01","02","03","04","05","06","07","08","09","10"
        ,"11","12","13","14","15","16","17","18","19","20"
        ,"21","22","23","24","25","26","27","28"
    ];
    abbrDays = [];

    monthInt = "00";
    day = "";
    year = "";

    faIconName = { faTrashCan };

    constructor() { }

    ngOnInit() { this.setDate(); }

    ngOnChanges(changes: SimpleChanges) {
        if (
            changes['modelDate'] 
            && !changes['modelDate'].firstChange
        ) { this.setDate(); }
    }

    setDate() {
        var dt = new Date();
        if (
            this.modelDate !== null 
            && this.modelDate !== undefined
        ) {
            dt = new Date(this.modelDate);
            this.isYearShowing = false;
            this.isMonthShowing = false;
            this.isDayShowing = false;
        } else {
            if (this.useAllButtons) {
                this.isYearShowing = true;
            }
        }

        var yy  = dt.getFullYear();
        var minYear = yy - this.yearsBefore;
        var maxYear = yy + this.yearsAfter;
        for (var i = minYear, len = maxYear + 1; i < len; i++ ) {
            this.years.push(i);
        }

        var mm = dt.getMonth() + 1;
        var dd = dt.getDate();            
        this.year = yy.toString();   

        if (mm < 10) { this.monthInt = "0" + mm.toString(); }
        else { this.monthInt = mm.toString(); }
        if (dd < 10) { this.day = "0" + dd.toString(); }
        else { this.day = dd.toString(); }

        for (var i = 0, len = this.months?.length; i < len; i++ ) {
            if (this.months[i][0].toString() === this.monthInt ) {
                this.changeMonth(this.months[i][0]);
                break;
            }
        }
    }

    changeYear(y: number) {
        if (!this.isLeapYear(y) && this.day === "29") { this.day = "28"; }
        this.year = y.toString();
        if (this.year !== null) {
            if (this.isLeapYear(+this.year)) { 
                this.is31Days = false;
                this.is30Days = false;
                this.is29Days = true; 
                this.is28Days = false; 
                this.abbrDays = ["01", "29", "Other"];
            } else { 
                this.is31Days = false;
                this.is30Days = false;
                this.is29Days = false; 
                this.is28Days = true; 
                this.abbrDays = ["01", "28", "Other"];
            }
        }
    }

    changeMonth(m) {
        this.abbrDays = []
        this.monthInt = m;
        if (
            m === "04" 
            || m === "06" 
            || m === "09" 
            || m === "11"
        ) {
            this.is31Days = false;
            this.is30Days = true;
            this.is29Days = false;
            this.is28Days = false;
            this.abbrDays = ["01", "30", "Other"];
        } else if (m === "02") {
            if (this.year !== null) {
                if (this.isLeapYear(+this.year)) { 
                    this.is31Days = false;
                    this.is30Days = false;
                    this.is29Days = true; 
                    this.is28Days = false; 
                    this.abbrDays = ["01", "29", "Other"];
                } else { 
                    this.is31Days = false;
                    this.is30Days = false;
                    this.is29Days = false; 
                    this.is28Days = true; 
                    this.abbrDays = ["01", "28", "Other"];
                }
            }
        } else if (
            m === "01" 
            || m === "03" 
            || m === "05" 
            || m === "07" 
            || m === "08" 
            || m === "10" 
            || m === "12"
        ) {
            this.is31Days = true;
            this.is30Days = false;
            this.is29Days = false; 
            this.is28Days = false; 
            this.abbrDays = ["01", "31", "Other"];
        } else {
            this.monthInt = "MON";
            this.day = "";
            this.is31Days = false;
            this.is30Days = false;
            this.is29Days = false;
            this.is28Days = false;
        }
    }

    changeDay(d: string) {
        if (d === "Other") {
            this.isAbrreviatedDays = false;
            if (
                this.monthInt === "04"
                || this.monthInt === "06" 
                || this.monthInt === "09" 
                || this.monthInt === "11"
            ) {
                this.is31Days = false;
                this.is30Days = true;
                this.is29Days = false; 
                this.is28Days = false; 
            } else if (this.monthInt === "02") {
                if (this.year !== null) {
                    if (this.isLeapYear(+this.year)) { 
                        this.is31Days = false;
                        this.is30Days = false;
                        this.is29Days = true; 
                        this.is28Days = false; 
                    } else { 
                        this.is31Days = false;
                        this.is30Days = false;
                        this.is29Days = false; 
                        this.is28Days = true; 
                    }
                }
            } else if (
                this.monthInt === "01" 
                || this.monthInt === "03" 
                || this.monthInt === "05" 
                || this.monthInt === "07" 
                || this.monthInt === "08" 
                || this.monthInt === "10" 
                || this.monthInt === "12"
            ) {
                this.is31Days = true;
                this.is30Days = false;
                this.is29Days = false; 
                this.is28Days = false; 
            }
        } else {
            this.day = d;
            this.modelDate = new Date(+this.year, +this.monthInt - 1, +this.day);
            this.modelDateOut.emit(this.modelDate);
        }
    }

    buttonYear(y: number) {
        this.isYearShowing = false;
        this.isMonthShowing = true;
        this.isDayShowing = false;
        this.changeYear(y);
    }

    buttonMonth(m) {
        this.isYearShowing = false;
        this.isMonthShowing = false;
        this.isDayShowing = true;
        this.changeMonth(m);
    }

    buttonDay(d: string) {
        this.isYearShowing = false;
        this.isMonthShowing = false;
        if (d !== "Other") { this.isDayShowing = false; }
        this.changeDay(d);
    }

    clearButtonDate() {
        this.modelDate = null;
        this.isYearShowing = true;
        this.modelDateOut.emit(this.modelDate);
    }

    isLeapYear(y: number) { return y % 4 === 0 && (y % 100 !== 0 || y % 400 === 0); }
}
